import { jsxs as h, Fragment as w, jsx as e } from "react/jsx-runtime";
import M, { forwardRef as y, useRef as g, useCallback as x } from "react";
import { InfoModal as C } from "./info-modal.js";
import v from "./close-icon.svg.js";
const I = y(
  (n, a) => {
    const {
      actionButtonText: r,
      price: c,
      learnMoreLink: s,
      startMyWillLink: d,
      onStartMyWillClick: f,
      closeOnLinkClick: l,
      requireAccount: m,
      onRequireAccount: u
    } = n, t = g(null), p = n.bannerText ?? "From";
    M.useImperativeHandle(a, () => ({
      openModal: () => {
        var o;
        return (o = t.current) == null ? void 0 : o.openModal();
      },
      closeModal: () => {
        var o;
        return (o = t.current) == null ? void 0 : o.closeModal();
      }
    }));
    const k = x(
      (o) => {
        var i;
        l && (o.preventDefault(), (i = t.current) == null || i.closeModal());
      },
      [l]
    ), b = n.description ?? /* @__PURE__ */ h(w, { children: [
      "Get peace of mind with our online will creation service",
      " ",
      /* @__PURE__ */ e("span", { style: { fontWeight: "700" }, children: "$199" }),
      " ",
      "for singles, or",
      " ",
      /* @__PURE__ */ e("span", { style: { fontWeight: "700" }, children: "$299" }),
      " ",
      "or a mirror will for your spouse.",
      /* @__PURE__ */ e("br", {}),
      "An easy, step-by-step process that won't take long. ",
      /* @__PURE__ */ e("br", {}),
      /* @__PURE__ */ e(
        "a",
        {
          href: s,
          target: "_blank",
          rel: "noopener noreferrer",
          onClick: k,
          children: "Learn more."
        }
      ),
      /* @__PURE__ */ e("br", {})
    ] });
    return /* @__PURE__ */ e(
      C,
      {
        ref: t,
        image: "/wills/will-info-header-desktop.webp",
        mobileImage: "/wills/will-info-header-mobile.webp",
        description: b,
        bannerText: p,
        price: c,
        termsTitle: "Will creation privacy and terms",
        actionButton: m ? {
          text: r ?? "Get started - create account",
          onClick: u
        } : {
          text: r ?? "Start my will",
          link: d,
          onClick: f
        },
        closeIcon: /* @__PURE__ */ e(v, {})
      }
    );
  }
);
I.displayName = "WillInfoModal";
export {
  I as WillInfoModal
};
